export const authenticityOptions = [
  { id: '1', label: 'Best', value: 'best' },
  { id: '2', label: 'High', value: 'high' },
  { id: '3', label: 'Decent', value: 'decent' },
];

export const formatFilterLocations = (locations) => {
  let formattedLocations = '';
  locations = locations?.map((loc) => loc?.split(',')[0]);
  if (locations.length > 2) {
    formattedLocations = `${locations.slice(0, 2).join(', ')} + ${locations.length - 2} more`;
  } else {
    formattedLocations = locations.join(', ');
  }
  return formattedLocations;
};

export const lastPostOptions = [
  { id: '1', label: 'In the last month', value: 30 },
  { id: '2', label: 'In the last 2 months', value: 60 },
  { id: '3', label: 'In the last 3 months', value: 90 },
];

export const genderOptions = [
  { id: '1', label: 'Male', value: 'MALE' },
  { id: '2', label: 'Female', value: 'FEMALE' },
];

export const searchTypeDropdownData = [
  {
    id: '1',
    label: 'Show influencers who talk about',
    value: 'hashtag',
    description: 'Search for keywords or hashtags',
    isNew: false,
  },
  {
    id: '2',
    label: 'Show influencers who mention',
    value: 'brand',
    description: "See a large brand's influencers",
    isNew: false,
  },
  {
    id: '3',
    label: 'Show influencers similar to',
    value: 'lookalikes',
    description: 'Find similar influencers',
    isNew: false,
  },
  {
    id: '4',
    label: 'Show influencers who follow',
    value: 'followers',
    description: 'Find your brand’s influential followers',
    isNew: true,
  },
];
export const andOrSelect = [
  { id: '1', label: 'AND', value: 'and', hint: 'narrow' },
  { id: '2', label: 'OR', value: 'or', hint: 'expand' },
];

export const SHORTS_PLATFORM = 'shorts';
export const TIKTOK_PLATFORM = 'tiktok';
export const YOUTUBE_PLATFORM = 'youtube';
export const INSTAGRAM_PLATFORM = 'instagram';

export const platfomDropdownData = [
  { id: '1', label: 'Instagram', value: INSTAGRAM_PLATFORM },
  { id: '2', label: 'TikTok', value: TIKTOK_PLATFORM },
  { id: '3', label: 'YouTube', value: YOUTUBE_PLATFORM },
  { id: '4', label: 'Shorts', value: SHORTS_PLATFORM },
];

export const getPlaceHolderText = (searchType) => {
  switch (searchType) {
    case 'multi-keyword':
      return 'You can add more keywords';
    case 'hashtag':
      return 'A primary topic of interest, eg: #wellnesswednesday';
    case 'brand':
      return 'A popular brand, eg: "Sephora"';
    case 'lookalikes':
      return 'Username here, eg: "@timferris"';
    case 'followers':
      return 'Enter your brand’s username to find influential followers';
    default:
      return '';
  }
};

export const createList = (array1, array2) => {
  let map2 = new Map();
  array2?.forEach((item) => {
    map2.set(item._id, item);
  });

  // Step 2: Initialize arrays to store results
  let commonElements = [];
  let nonCommonElements = [];
  let mixedElements = [];

  // Step 3: Loop through array1 and categorize elements
  array1?.forEach((item) => {
    if (map2.has(item._id)) {
      // Found in both arrays (common element)
      commonElements.push(item);
    } else {
      // Not found in array2 (non-common element)
      nonCommonElements.push(item);
    }
  });

  // Step 4: Loop through array2 to find non-common elements
  array2?.forEach((item) => {
    if (!map2.has(item._id)) {
      // Not found in array1 (non-common element)
      nonCommonElements.push(item);
    }
    // No need to handle common elements from array2 again
  });

  // Step 5: Combine common and non-common elements for mixed elements
  mixedElements = commonElements.concat(nonCommonElements);

  return { commonElements, nonCommonElements, mixedElements };
};
